module.exports = __webpack_public_path__ + "img/msoffice.8a7db427.png";